import { render, staticRenderFns } from "./DashboardPendingRequestsCard.vue?vue&type=template&id=5960f355&"
import script from "./DashboardPendingRequestsCard.vue?vue&type=script&lang=js&"
export * from "./DashboardPendingRequestsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports